import { atom, selector } from 'recoil';

import { EanEligibilityOutResponse } from '../models/EanEligibilityOutResponse';
import { EanEligibilityStatusEnum } from '../enum/EanEligibilityStatusEnum';
import { EanUtils } from '../common/eanUtils';
import { SDPTariffChoiceEnum } from '../enum/SDPTariffChoiceEnum';
import { STEP_ASK_CONTENT_METER_ID } from '../components/meterOnboarding/StepAskConsentMeter';
import { STEP_NO_ACCESS_METER_ID } from '../components/meterOnboarding/StepNoAcccessMeter';

export interface MeterOnboardingStateProps {
  ean: string;
  eanEligibilityOutResponse: EanEligibilityOutResponse;
  isAccMember?: boolean;
  tariff?: SDPTariffChoiceEnum;
  name?: string;
  email?: string;
  steps?: { id: string }[];
  totalSteps?: number;
  activeStepIndex?: number;
}
export const meterOnboardingState = atom<MeterOnboardingStateProps>({
  key: 'meterOnboardingState',
  default: {
    ean: '',
    eanEligibilityOutResponse: {} as EanEligibilityOutResponse,
    isAccMember: false,
    steps: [],
    totalSteps: 0,
    activeStepIndex: 0,
  },
});

export const wizardActiveStepIdState = selector<string | null>({
  key: 'wizardActiveStepId',
  get: ({ get }) => {
    const steps = get(meterOnboardingState).steps;
    const stepIndex = get(meterOnboardingState).activeStepIndex;
    if (steps && steps.length && stepIndex !== undefined) {
      return steps[stepIndex].id;
    }
    return null;
  },
});

export const wizardTotalStepState = selector<EanEligibilityStatusEnum>({
  key: 'wizardTotalStep',
  get: ({ get }) => {
    const eligibilityStatus = EanUtils.getEanEligibilityStatus(
      get(meterOnboardingState).eanEligibilityOutResponse.code
    );
    if (eligibilityStatus !== EanEligibilityStatusEnum.Invalid) {
      if (eligibilityStatus === EanEligibilityStatusEnum.Success) {
        return 4;
      } else if (eligibilityStatus === EanEligibilityStatusEnum.AskConsent) {
        return 3;
      } else if (eligibilityStatus === EanEligibilityStatusEnum.ContractNotRegisteredWithEmail) {
        return 2;
      }
    }
    return 0;
  },
});

export const wizardStartStepState = selector<EanEligibilityStatusEnum>({
  key: 'wizardStartStep',
  get: ({ get }) => {
    const eligibilityStatus = EanUtils.getEanEligibilityStatus(
      get(meterOnboardingState).eanEligibilityOutResponse.code
    );
    const steps = get(meterOnboardingState).steps;
    const stepIndex = get(meterOnboardingState).activeStepIndex;
    if (
      eligibilityStatus !== EanEligibilityStatusEnum.Invalid &&
      steps &&
      stepIndex !== undefined
    ) {
      if (eligibilityStatus === EanEligibilityStatusEnum.AskConsent) {
        return stepIndex! - steps!.findIndex((s) => s.id === STEP_ASK_CONTENT_METER_ID) + 1;
      } else if (eligibilityStatus === EanEligibilityStatusEnum.ContractNotRegisteredWithEmail) {
        return stepIndex! - steps!.findIndex((s) => s.id === STEP_NO_ACCESS_METER_ID) + 1;
      } else {
        return stepIndex!;
      }
    }
    return 0;
  },
});
